import React, { useState } from 'react';
import Dialog from '@components/Atoms/Dialog';
import Typography from '@components/Atoms/Typography';
import Box from '@components/Atoms/Box';
import { LockStrategy } from '../../types';
import LockStrategyRadio from './LockStrategyRadio';

const LockConfirmationDialog = ({
  onCancel,
  onConfirm,
  open,
  testletLockStrategy,
}: {
  onCancel: () => void;
  onConfirm: (lockStrategy: LockStrategy) => void;
  open: boolean;
  testletLockStrategy?: LockStrategy;
}) => {
  const [lockStrategy, setLockStrategy] = useState<LockStrategy>(testletLockStrategy ?? LockStrategy.USE_REMAINING_TIME);

  return (
    <Dialog
      actions={[
        {
          buttonProps: {
            variant: 'outlined',
            dataTestId: 'cancel-exam-action-dialog',
          },
          label: 'Cancel',
          onClick: onCancel,
        },
        {
          buttonProps: {
            variant: 'contained',
            dataTestId: 'confirm-exam-action-dialog',
            color: 'play',
          },
          label: 'Lock',
          onClick: () => onConfirm(lockStrategy),
        },
      ]}
      open={open}
      onClose={onCancel}
      data-testid="exam-action-dialog"
      title="Lock Exam"
    >
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <Typography
          sx={{
            textAlign: 'start',
          }}
          variant="body2"
        >
          Are you sure you want to lock the exam?
        </Typography>
        <Typography
          sx={{
            textAlign: 'start',
            mb: 1,
          }}
          variant="body2"
          fontWeight={500}
        >
          This will prevent the students who have not taken the exam from starting.
        </Typography>
        <LockStrategyRadio
          lockStrategy={lockStrategy}
          setLockStrategy={setLockStrategy}
        />
      </Box >
    </Dialog >
  );
};

export default LockConfirmationDialog;
